// Interfaces for nivoConsts data
export interface FormPayloadTypes {
  type?: string,
  therapy_drug?: string,
  cancerType?: string,
  therapy?: string,
  indication?: string,
  is_drug_free: 1 | 0,
  cycle_number?: string,
  next_cycle_date?: string,
  current_dosage?: string,
  upcoming_cycle_date?: string,
  upcoming_dosage?: string,
  isRewardsAssign?: boolean,
  cycles_completed?: number,
  notes?: string,
  brain_mets?: 1 | 0,
}
export interface LabelValue {
  label: string;
  value: string;
}
export interface ProgramType extends LabelValue {
  theapyDrugs?: LabelValue[];
}

export interface TherapyOption extends LabelValue {
  indications: LabelValue[];
}

export interface CancerType extends LabelValue {
  therapies: TherapyOption[];
}

export interface NivolumabOptions {
  nivolumab: CancerType[];
  sigrima: CancerType[];
  tucatinib: CancerType[];
}

export const programTypes: ProgramType[] = [
  {
    label: "Sigrima",
    value: "sigrima",
    theapyDrugs: [
      {
        label: "Sigrima",
        value: "sigrima",
      },
      {
        label: "Others",
        value: "others",
      },
    ],
  },
  {
    label: "Nivolumab",
    value: "nivolumab",
    theapyDrugs: [
      {
        label: "Nivolumab",
        value: "nivolumab",
      },
    ],
  },
  {
    label: "Tucatinib",
    value: "tucatinib",
    theapyDrugs: [
      {
        label: "Tucatinib",
        value: "tucatinib",
      },
    ],
  },
];

export const nivolumabOptions: NivolumabOptions = {
  nivolumab: [
    {
      label: "NSCLC – Non-Small Cell Lung Cancer",
      value: "NSCLC – Non-Small Cell Lung Cancer",
      therapies: [
        {
          label: "Neo - Adjuvant",
          value: "Neo - Adjuvant",
          indications: [
            {
              label:
                "In Combination with platinum doublet chemotherapy (Pemetrexed+Carbo/Pacli+Carbo)",
              value: "In Combination with platinum doublet chemotherapy (Pemetrexed+Carbo/Pacli+Carbo)",
            },
          ],
        },
        {
          label: "1L",
          value: "1L",
          indications: [
            {
              label:
                "In Combination with Ipilimumab + Platinum Chemo (Pem+Cis/Carbo)",
              value: "In Combination with Ipilimumab + Platinum Chemo (Pem+Cis/Carbo)",
            },
            {
              label: "Chemo free regimen​",
              value: "Chemo free regimen​",
            },
          ],
        },
        {
          label: "2L",
          value: "2L",
          indications: [
            {
              label: "Single agent​",
              value: "Single agent​",
            },
          ],
        },
      ],
    },
    {
      label: "GI – Gastrointestinal",
      value: "GI – Gastrointestinal",
      therapies: [
        {
          label: "1L Gastric",
          value: "1L Gastric",
          indications: [
            {
              label:
                "In combination with Fluoropyrimidine & platinum (Cisplatin) containing chemo",
              value: "In combination with Fluoropyrimidine & platinum (Cisplatin) containing chemo",
            },
          ],
        },
        {
          label: "GEJC",
          value: "GEJC",
          indications: [
            {
              label:
                "In combination with Fluoropyrimidine & platinum (Cisplatin) containing chemo",
              value: "In combination with Fluoropyrimidine & platinum (Cisplatin) containing chemo",
            },
          ],
        },
        {
          label: "EAC",
          value: "EAC",
          indications: [
            {
              label:
                "In combination with Fluoropyrimidine & platinum (Cisplatin) containing chemo",
              value: "In combination with Fluoropyrimidine & platinum (Cisplatin) containing chemo",
            },
          ],
        },
        {
          label: "1L ESCC",
          value: "1L ESCC",
          indications: [
            {
              label:
                "In combination with Fluoropyrimidine & platinum (Cisplatin) containing chemo",
              value: "In combination with Fluoropyrimidine & platinum (Cisplatin) containing chemo",
            },
          ],
        },
        {
          label: "2L ESCC",
          value: "2L ESCC",
          indications: [
            {
              label: "Single Agent",
              value: "Single Agent",
            },
          ],
        },
        {
          label: "ADJ. Eso",
          value: "ADJ. Eso",
          indications: [
            {
              label: "Single Agent",
              value: "Single Agent",
            },
          ],
        },
      ],
    },
    {
      label: "RCC – Renal Cell Carcinoma",
      value: "RCC – Renal Cell Carcinoma",
      therapies: [
        {
          label: "1L",
          value: "1L",
          indications: [
            {
              label: "In combination with Cabozantinib",
              value: "In combination with Cabozantinib",
            },
            {
              label: "In Combination with Ipilimumab",
              value: "In Combination with Ipilimumab",
            },
          ],
        },
        {
          label: "2L",
          value: "2L",
          indications: [
            {
              label: "Single Agent",
              value: "Single Agent",
            },
          ],
        },
      ],
    },
    {
      label: "SCCHN – Squamous Cell Carcinoma of the Head and Neck",
      value: "SCCHN – Squamous Cell Carcinoma of the Head and Neck",
      therapies: [
        {
          label: "2L",
          value: "2L",
          indications: [
            {
              label:
                "Nivolumab is approved in patients with SCCHN after platinum-based therapy",
              value: "Nivolumab is approved in patients with SCCHN after platinum-based therapy",
            },
          ],
        },
      ],
    },
    {
      label: "Urothelial Carcinoma",
      value: "Urothelial Carcinoma",
      therapies: [
        {
          label: "Adjuvant",
          value: "Adjuvant",
          indications: [
            {
              label: "Single Agent",
              value: "Single Agent",
            },
          ],
        },
        {
          label: "2L",
          value: "2L",
          indications: [
            {
              label: "Single Agent",
              value: "Single Agent",
            },
          ],
        },
      ],
    },
    {
      label: "Melanoma",
      value: "Melanoma",
      therapies: [
        {
          label: "Adjuvant",
          value: "Adjuvant",
          indications: [
            {
              label: "Single Agent",
              value: "Single Agent",
            },
          ],
        },
        {
          label: "Metastatic",
          value: "Metastatic",
          indications: [
            {
              label: "Single Agent",
              value: "Single Agent",
            },
          ],
        },
      ],
    },
    {
      label: "CHL – Classical Hodgkin Lymphoma",
      value: "CHL – Classical Hodgkin Lymphoma",
      therapies: [
        {
          label: "Metastatic",
          value: "Metastatic",
          indications: [
            {
              label: "Single Agent",
              value: "Single Agent",
            },
          ],
        },
      ],
    },
    {
      label: "mCRC – Metastatic Colorectal Cancer",
      value: "mCRC – Metastatic Colorectal Cancer",
      therapies: [
        {
          label: "Metastatic",
          value: "Metastatic",
          indications: [
            {
              label: "Single Agent",
              value: "Single Agent",
            },
          ],
        },
      ],
    },
  ],
  sigrima: [
    {
      label: "Breast Cancer",
      value: "Breast Cancer",
      therapies: [
        {
          label: "Neoadjuvant (before surgery)",
          value: "Neoadjuvant (before surgery)",
          indications: [],
        },
        {
          label: "Adjuvant (after surgery)",
          value: "Adjuvant (after surgery)",
          indications: [],
        },
        {
          label: "Metastatic 1st line",
          value: "Metastatic 1st line",
          indications: [],
        },
        {
          label: "Metastatic 2nd line & beyond",
          value: "Metastatic 2nd line & beyond",
          indications: [],
        },
      ],
    },
  ],
  tucatinib: [
    {
      label: "Breast Cancer",
      value: "Breast Cancer",
      therapies: [
        {
          label: "MBC",
          value: "MBC",
          indications: [],
        },
        {
          label: "MBC 1st line",
          value: "MBC 1st line",
          indications: [{
            label: "Tucatinib+ trastuzumab and capecitabine",
            value: "Tucatinib+ trastuzumab and capecitabine",
          }, {
            label: "Tucatinib+trastuzumab",
            value: "Tucatinib+trastuzumab",
          }],
        },
        {
          label: "MBC 2nd line",
          value: "MBC 2nd line",
          indications: [{
            label: "Tucatinib+ trastuzumab and capecitabine",
            value: "Tucatinib+ trastuzumab and capecitabine",
          }, {
            label: "Tucatinib+trastuzumab",
            value: "Tucatinib+trastuzumab",
          }],
        },
        {
          label: "MBC 3rd line",
          value: "MBC 3rd line",
          indications: [{
            label: "Tucatinib+ trastuzumab and capecitabine",
            value: "Tucatinib+ trastuzumab and capecitabine",
          }, {
            label: "Tucatinib+trastuzumab",
            value: "Tucatinib+trastuzumab",
          }],
        },
      ],
    },
  ],
};

export const freeOrPaidOptions = [
  { label: "Free Drug", value: 1 },
  { label: "Paid Drug", value: 0 },
];

export const sessionFields = [
  {
    type: "text",
    label: "Cycle/Session Number",
    name: "cycle_number",
    placeholder: "Enter Cycle/Session Number",
    disabled: true,
  },
  // {
  //   type: "date",
  //   label: "Enter Current cycle/session date",
  //   name: "next_cycle_date",
  //   min: new Date().toISOString().split("T")[0],
  // },
  // {
  //   type: "text",
  //   label: "Enter Current Dosage(mg)",
  //   name: "current_dosage",
  // },
  {
    type: "date",
    label: "Upcoming cycle/session date",
    name: "upcoming_cycle_date",
    min: new Date().toISOString().split("T")[0],
    placeholder: "Select Upcoming Cycle/Session Date",
  },
  {
    type: "text",
    label: "Upcoming Dosage(mg)",
    name: "upcoming_dosage",
    placeholder: "Enter Upcoming Dosage(mg)",
    nivoOnly: true,
  },
  {
    type: "dropdown",
    label: "Free or paid Drug?",
    name: "is_drug_free",
    options: freeOrPaidOptions,
    nivoOnly: true,
  },
  {
    type: "textarea",
    label: "Notes",
    name: "notes",
    placeholder: "Enter Notes",
  },
];

export const chemotherapySessions = [
  { label: "0", value: "0" },
  { label: "1 or more", value: "1" },
];

export const DEFAULT_CARE_COINS = 250;
export const NIVOLUMAB = 'nivolumab';
export const TUCATINIB = 'tucatinib';
